import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import api, { apiErr, fmtDate } from "@/lib/api";
import { Loading } from "@/components/site/ui";
import { Panel, AdminHeading, Th, Td, adminInput } from "@/components/admin/ui";
import StatusBadge from "@/components/StatusBadge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const TYPES = ["Birthday", "Anniversary", "Family gathering", "Dinner", "Pool party", "Watch party", "Holiday gathering", "Celebration", "Custom event"];

export default function AdminEvents() {
  const [items, setItems] = useState(null);
  const [f, setF] = useState({ event_type: "Birthday", requested_date: "", start_time: "18:00", end_time: "23:00", attendance: 10, children: 0, contact_name: "", contact_email: "", budget: 0, special_requests: "" });
  const nav = useNavigate();
  const load = () => api.get("/admin/events").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const create = async () => {
    if (!f.requested_date) { toast.error("Requested date required."); return; }
    try { await api.post("/admin/events", f); toast.success("Event request created."); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <div>
      <AdminHeading title="Private Events" subtitle="Requests, approval, timeline, checklist, guest list, vendors & expenses.">
        <Dialog><DialogTrigger asChild><button className="btn-gold px-5 py-2.5 text-sm flex items-center gap-2" data-testid="new-event-btn"><Plus size={15} /> New Event</button></DialogTrigger>
          <DialogContent className="bg-surface border-white/10 max-w-lg"><DialogHeader><DialogTitle className="font-serif text-2xl">New Event Request</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <select className={adminInput} value={f.event_type} onChange={(e) => set("event_type", e.target.value)} data-testid="event-type">{TYPES.map((t) => <option key={t}>{t}</option>)}</select>
              <div className="grid grid-cols-3 gap-3">
                <input type="date" className={adminInput} value={f.requested_date} onChange={(e) => set("requested_date", e.target.value)} data-testid="event-date" />
                <input type="time" className={adminInput} value={f.start_time} onChange={(e) => set("start_time", e.target.value)} />
                <input type="time" className={adminInput} value={f.end_time} onChange={(e) => set("end_time", e.target.value)} />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <input type="number" className={adminInput} placeholder="Attendance" value={f.attendance} onChange={(e) => set("attendance", +e.target.value)} />
                <input type="number" className={adminInput} placeholder="Children" value={f.children} onChange={(e) => set("children", +e.target.value)} />
              </div>
              <input className={adminInput} placeholder="Contact name" value={f.contact_name} onChange={(e) => set("contact_name", e.target.value)} />
              <input className={adminInput} placeholder="Contact email" value={f.contact_email} onChange={(e) => set("contact_email", e.target.value)} />
              <input type="number" className={adminInput} placeholder="Budget" value={f.budget} onChange={(e) => set("budget", +e.target.value)} />
              <textarea className={adminInput} rows={2} placeholder="Special requests" value={f.special_requests} onChange={(e) => set("special_requests", e.target.value)} />
              <button onClick={create} className="btn-gold w-full py-2.5 text-sm" data-testid="event-save">Create Request</button>
            </div>
          </DialogContent>
        </Dialog>
      </AdminHeading>
      <Panel>
        {items === null ? <Loading /> : items.length === 0 ? <p className="text-sm text-muted-foreground py-4 text-center">No event requests.</p> : (
          <div className="overflow-x-auto"><table className="w-full min-w-[640px]">
            <thead><tr><Th>Type</Th><Th>Date</Th><Th>Attendance</Th><Th>Contact</Th><Th>Status</Th></tr></thead>
            <tbody>{items.map((e) => (
              <tr key={e.id} className="cursor-pointer hover:bg-white/5" onClick={() => nav(`/admin/events/${e.id}`)} data-testid={`event-row-${e.id}`}>
                <Td>{e.event_type}</Td><Td className="text-muted-foreground">{fmtDate(e.requested_date)}</Td>
                <Td>{e.attendance} guests</Td><Td className="text-muted-foreground">{e.contact_name}<span className="block text-xs">{e.contact_email}</span></Td>
                <Td><StatusBadge status={e.status} /></Td>
              </tr>
            ))}</tbody>
          </table></div>
        )}
      </Panel>
    </div>
  );
}
